import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import VoucherIncomeTable from './IncomeTable'
import { Box } from '@chakra-ui/react';

const Income = () => {
    return (
        <div>
            <HeaderSection
                title="View Income"
                breadcrumb={["Dashboard", "Voucher", "Income"]}
            />
            <Box p={6}>

                <VoucherIncomeTable />
            </Box>
        </div>
    )
}

export default Income